export default {
  name: [
    { required: true, message: 'Prosím zadajte vaše ctené meno', trigger: 'change' },
  ],
  email: [
    {
      required: true, type: 'email', message: 'Prosím zadajte váš ctený e-mail', trigger: 'blur',
    },
  ],
  // recaptcha: [
  //   { required: true, message: 'Prosím zaškrtnite, že nie ste robot.', trigger: 'change' },
  // ],
  content: [
    { required: true, message: 'Prosím zadajte nejaký text', trigger: 'change' },
  ],
  gdpr: [
    {
      required: true, type: 'boolean', trigger: 'change',
    },
    {
      validator: (rule, value, cb) => {
        if (!value) {
          cb(new Error('Ak chcete pridať príspevok zaškrtnite súhlas s podmienkami'))
          return
        }
        cb()
      },
    },
  ],
}



// WEBPACK FOOTER //
// ./src/components/Form/validation.js